import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";

const ROWS = [
  { size: "S", chest: '36–38" / 91–97cm', length: '27" / 69cm', shoulder: '17" / 43cm' },
  { size: "M", chest: '38–40" / 97–102cm', length: '28" / 71cm', shoulder: '18" / 46cm' },
  { size: "L", chest: '40–42" / 102–107cm', length: '29" / 74cm', shoulder: '19" / 48cm' },
  { size: "XL", chest: '42–44" / 107–112cm', length: '30" / 76cm', shoulder: '20" / 51cm' },
  { size: "XXL", chest: '44–46" / 112–117cm', length: '31" / 79cm', shoulder: '21" / 53cm' },
];

export const SizeChart = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      data-testid="size-chart-modal"
      className="max-w-lg border-border bg-background"
    >
      <DialogHeader>
        <DialogTitle className="font-display text-xl font-bold uppercase tracking-tight">
          Size Chart
        </DialogTitle>
      </DialogHeader>
      <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
        TRAILNONE fits oversized — size down for a regular fit
      </p>
      <table className="mt-4 w-full text-left text-sm">
        <thead>
          <tr className="border-b border-border font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            <th className="py-2 pr-4">Size</th>
            <th className="py-2 pr-4">Chest</th>
            <th className="py-2 pr-4">Length</th>
            <th className="py-2">Shoulder</th>
          </tr>
        </thead>
        <tbody>
          {ROWS.map((r) => (
            <tr key={r.size} className="border-b border-border/60">
              <td className="py-2.5 pr-4 font-mono font-bold text-signal">{r.size}</td>
              <td className="py-2.5 pr-4">{r.chest}</td>
              <td className="py-2.5 pr-4">{r.length}</td>
              <td className="py-2.5">{r.shoulder}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </DialogContent>
  </Dialog>
);
